<template>
  <div :id="componentId" class="sp2-module-5" :style="moduleStyle">
    <div class="sp2-module-5-content" :style="contentStyle">
      <div class="sp2-industry-grid">
        <div
          v-for="(item, index) in displayList"
          :key="index"
          class="sp2-industry-item"
          :style="{ background: getItemBackground(index) }"
        >
          <span class="sp2-industry-text">{{ item.name || item }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
const GRADIENT_BACKGROUNDS = [
  'linear-gradient(90deg, #FEFEFF 0%, #F0E7FF 100%)',
  'linear-gradient(90deg, #FCFFFD 0%, #EEFFF6 100%)',
  'linear-gradient(90deg, #FEFFFF 0%, #D8F2FF 100%)',
  'linear-gradient(90deg, #FEFEFE 0%, #DDDFFF 100%)',
  'linear-gradient(90deg, #FEFEFE 0%, #FFE7E3 100%)'
];

export default {
  name: 'SpTwoModule5',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_5'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      backgroundImage: '',
      list: [
        { name: '知识产权' },
        { name: '医 疗' },
        { name: '品牌广告' },
        { name: '快 消' },
        { name: '科 技' },
        { name: '舆情公关' },
        { name: '品牌广告' },
        { name: '快 消' }
      ]
    };
  },
  computed: {
    displayList() {
      return (this.list || []).slice(0, 20);
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    },
    contentStyle() {
      return {
        backgroundImage: this.backgroundImage ? `url(${this.backgroundImage})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    }
  },
  methods: {
    getItemBackground(index) {
      return GRADIENT_BACKGROUNDS[index % GRADIENT_BACKGROUNDS.length];
    }
  }
};
</script>

<style scoped>
.sp2-module-5 {
  position: relative;
  width: 2000px;
  min-width: 2000px;
  max-width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-module-5-content {
  width: 1400px;
  margin: 0 auto;
  padding: 60px 70px;
  box-sizing: border-box;
}

.sp2-industry-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 40px 33px;
  width: 1260px;
}

.sp2-industry-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 289px;
  height: 135px;
  border-radius: 10px;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
}

.sp2-industry-text {
  display: block;
  width: 129px;
  height: 36px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #333333;
  line-height: 36px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
}
</style>
